import React, { useEffect } from "react";
import "./Pillars_Of_Majestry.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";
import { useDispatch, useSelector } from "react-redux";
import { getpillar } from "../../../features/aboutus/aboutusSlice";

function Pillars_Of_Majestry() {
  const pillarsData = [
    {
      img: "/assets/images/about-us/firmer.png",
      title: "2X Firmer",
      subtitle: "Ortho-Spring Tech",
      text:
        "High-grade, fire-treated springs that synchronize with your body’s movement to eliminate pressure points and protect your spine.",
      dark: false,
    },
    {
      img: "/assets/images/about-us/integrity.png",
      title: "Anti-Sag",
      subtitle: "Integrity",
      text:
        "We’ve mastered the art of durability. Our mattresses are engineered to resist trenching, providing consistent edge-to-edge support for years to come.",
      dark: false,
    },
    {
      img: "/assets/images/about-us/breathebility.png",
      title: "Aero Sleep",
      subtitle: "Breathability",
      text:
        "Using integrated temperature-regulating materials, we ensure constant airflow so you wake up refreshed, never overheated.",
      dark: true,
    },
  ];


  const pillar = useSelector((state) => state?.aboutus?.pillar);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getpillar());
  }, []);

  return (
    <section className="pillar_of_majestry">
      <div className="container">
        <Common_Title_2 title={"The Pillars of Majesty Innovation"} />

        <div className="row pillar_cards">
          {pillar?.map((item, index) => (
            <div key={index} className="col-lg-4 col-sm-6 mb-3">
              <div
                className={"pillar_card "}
              >
                <div className="pillar_icon">
                  <img src={process.env.REACT_APP_IMG_URL +item.image} alt={item?.name} className="pillar_img" />
                </div>

                <p
                  className={
                     "pillar_subtitle"
                  }
                >
                  {item?.name}
                  <br />
                  {item?.subname}
                </p>

                <p className="pillar_text">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pillars_Of_Majestry;
